<template>
  <div class="login-page--wrapper">
    <ui-scrollbar>
    <div
      class="login-page"
      :style="{
        backgroundImage: `url(static/img/background/${customBackground})`,
        backgroundPosition: customBackgroundPosition
      }"
    >
      <img v-if="customAntiCircle" src="static/img/substrate-desktop.svg" alt="Substrate" class="login-page__substrate-desktop">
      <img v-if="customAntiCircle" src="static/img/substrate-mobile.svg" alt="Substrate" class="login-page__substrate-mobile">
      <div class="login-page__container">
        <header class="login-page-header">
          <div class="login-page-header__container">
            <div class="login-page-logo">
              <img class="login-page-logo__img" :width="$store.state.isWidget ? 64 : 80" srcset="static/img/logo.png 1x, static/img/logo@2x.png 2x"  src="static/img/logo.png"  :alt="$t('common.title')">
              <h1 class="login-page-logo__text" v-html="$t('common.title')" /> 
            </div>
            <LangCheck :need-confirm-on-change="false" />
          </div>
        </header>

        <div class="login-page-content">
          <div class="login-page-content__container">
            <div>
              <div class="login-page-content__alert" :class="alertType" v-if="alertText">
                {{alertText}}
              </div>
              <div class="login-page-form">
                <div class="login-page-form__logo" v-if="!showLoginHelp">
                  <a :href="clientLink">
                    <picture>
                      <source id="s1" :srcset="logoSrcDefault" type="image/svg">
                      <img :src="logoSrc" alt="" onerror="this.src=document.getElementById('s1').srcset;">
                    </picture>
                  </a>
                </div>
                <div class="login-page-form__legend">
                  <span v-if="!validationError && !notificationText">{{ $t('login.students_login') }}</span>
                  <span v-else-if="validationError" class="login-page-form__error">{{ validationError }}</span>
                  <span v-else class="login-page-form__notification">{{ notificationText }}</span>
                </div>
                <div class="login-page-form__form-container">
                  <authenticate
                    @login-success="onLoginSuccess"
                    @login-canceled="onLoginCancel"
                    @getError="showError"
                    @hideError="hideError"
                    @recoveryCodeSended="onRecoveryCodeSended"
                    @passwordChanged="onPasswordChanged"
                    @showCreateAcc="onShowCreateAcc"
                    @showForgotPassword="onShowForgotPassword"
                    :show-cancel="false"
                    :createAccInfo="showLoginHelp"
                    ref="form"
                    :createAccText="createAccText"
                  >
                  </authenticate>
                  <!-- <div
                    class="login-page-form__create-account-text"
                    v-if="createAccInfo"
                  >
                    
                  </div> -->
                </div>
                <div class="login-page-form__create-account" v-if="showLoginHelp">
                  <div 
                    class="login-page-form__help-login-text" 
                    @click.prevent="showLoginHelp = !showLoginHelp" 
                    v-if="showLoginHelp"
                  >
                    <span>{{ $t('login.enter_system') }}</span>
                  </div>
                  <!-- <a href="/" class="login-page-form__enterby" v-else>
                    <span>Войти с помощью</span>
                    <img src="static/img/logos/gos_logo.svg" alt="Гос услуги">
                  </a> -->
                  <!-- <div
                    class="login-page-form__create-account-link"
                    @click="showCreateAcc(), hideError()"
                  >
                    <span v-if="createAccInfo">{{ $t('login.enter_system') }}</span>
                  </div> -->
                  <!-- <div
                    class="login-page-form__create-account-link"
                    @click="showCreateAcc(), hideError()"
                  >
                    <span v-if="!createAccInfo">Как получить аккаунт?</span>
                    <span v-else>{{ $t('login.enter_system') }}</span>
                  </div> -->
                </div>
              </div>
            </div>
            <div
              v-if="!$store.state.isWidget"
              class="login-page-slider"
            >
              <!-- <div class="login-page-slider__navigation">
                <div
                  class="login-page-slider__navigation-item login-page-slider__navigation-item--prev swiper-button-prev">
                  <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 0L0 7L7 14" transform="translate(1.11475 1)" stroke="#3268A6" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <div
                  class="login-page-slider__navigation-item login-page-slider__navigation-item--next swiper-button-next">
                  <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0L7 7L0 14" transform="translate(1.11475 1)" stroke="#3268A6" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              </div> -->
              <swiper :options="swiperOption">
                <swiper-slide class="login-page-slider__item">
                  <h2 :style="{color: customH2Color}" v-html="$t('common.title')" /> 
                  <div class="login-page-slider__item-content">
                    <div class="login-page-slide-advantages">
                      <div class="login-page-slide-advantages__item">
                        <div :style="{background: customAdvantagesCircleBackground}" class="login-page-slide-advantages__icon login-page-slide-advantages__icon--orange">
                          <img src="static/img/login-page_slide-1_icon-1.svg" :alt="$t('login.slides.slide1_text')">
                        </div>
                        <h3 :style="{color: customAdvantagesColor}" class="login-page-slide-advantages__title">
                          {{ $t('login.slides.slide1_text') }}
                        </h3>
                      </div>
                      <div class="login-page-slide-advantages__item">
                        <div :style="{background: customAdvantagesCircleBackground}" class="login-page-slide-advantages__icon login-page-slide-advantages__icon--green">
                          <img src="static/img/login-page_slide-1_icon-2.svg" :alt="$t('login.slides.slide2_text')">
                        </div>
                        <h3 :style="{color: customAdvantagesColor}" class="login-page-slide-advantages__title">
                          {{ $t('login.slides.slide2_text') }}
                        </h3>
                      </div>
                      <div class="login-page-slide-advantages__item">
                        <div :style="{background: customAdvantagesCircleBackground}" class="login-page-slide-advantages__icon login-page-slide-advantages__icon--purple">
                          <img src="static/img/login-page_slide-1_icon-3.svg" :alt="$t('login.slides.slide3_text')">
                        </div>
                        <h3 :style="{color: customAdvantagesColor}" class="login-page-slide-advantages__title">
                          {{ $t('login.slides.slide3_text') }}
                        </h3>
                      </div>
                    </div>
                  </div>
                </swiper-slide>
                <!-- <swiper-slide class="login-page-slider__item">
                  <h2>Удобная запись для пациентов</h2>
                  <div class="login-page-slider__item-content">

                    <div class="login-page-slide-patient-record">
                      <a href="#" class="login-page-slide-patient-record__button">
                        Запись для пациентов
                      </a>
                      <div class="login-page-slide-patient-record__image">
                        <img src="static/img/login-page_slide-2_image.png"  srcset="static/img/login-page_slide-2_image.png 1x,   static/img/login-page_slide-2_image@2x.png 2x " alt="Запись для пациентов">
                      </div>
                    </div>
                  </div>
                </swiper-slide> -->
                <!-- <swiper-slide class="login-page-slider__item">
                  <h2>Последние обновления</h2>
                  <div class="login-page-slider__item-content">

                    <div class="login-page-slide-release">
                      <div class="login-page-slide-release__icon login-page-slide-release__icon--red">
                        <img src="static/img/login-page_slide-3_icon.svg" alt="Последние обновления">
                      </div>
                      <h3 class="login-page-slide-release__title">
                        Новый релиз системы
                      </h3>
                      <div class="login-page-slide-release__date">
                        10.08.2018
                      </div>
                      <p class="login-page-slide-release__text">
                        Вышел 1.0.0 релиз системы. Реализована функция амбулаторной записи на прием. Получить доступ для
                        входа в систему вы можете связавшись с руководителем вашего подразделения
                      </p>
                    </div>
                  </div>
                </swiper-slide> -->
              </swiper>
            </div>
          </div>
        </div>

        <footer
          v-if="!$store.state.isWidget"
          class="login-page-footer"
        >
          <div class="login-page-footer__wrapper">
            <div class="login-page-footer__container">
              <a :href="clientLink" target="_blank" class="login-page-footer-logo">
                <picture>
                  <source id="s2" :srcset="footerLogoSrcDefault" type="image/svg">
                  <img :src="footerLogoSrc" alt="" onerror="this.src=document.getElementById('s2').srcset;">
                </picture>
              </a>
              <!-- <div class="login-page-footer-link">
                <div class="login-page-footer-link__title">
                  Информация
                </div>
                <a href="#" class="login-page-footer-link__link">
                  О проекте
                </a>
              </div> -->
              <!-- <div class="login-page-footer-link">
                <div class="login-page-footer-link__title">
                  Служба тех.поддержки
                </div>
                <a href="#" class="login-page-footer-link__link">
                 support.doc@ya.ru
               </a>
              </div> -->
              <div class="login-page-footer-link">
                <div class="login-page-footer-link__title">
                  {{ $t('labels.enter') }}
                </div>
                <a :href="adminAppUrl" target="_blank" class="login-page-footer-link__link">
                  {{ $t('labels.for_employee') }}
                </a>
                <div
                  v-if="policyHref"
                  class="login-page-footer__policy"
                >
                  <a
                    :href="policyHref"
                    class="login-page-footer__policy-link"
                    target="_blank"
                  >
                    {{ $t('labels.privacy_policy') }}
                  </a>
                </div>
              </div>
              <a :href="technologyLink" class="login-page-logo-ldp">
                <div class="login-page-logo-ldp__container">
                  <img 
                    :src="isSnsEnabled ? 'static/img/thankdigit_tech_logo.svg' : 'static/img/ldp-logo_lion.svg'" 
                    :alt="isSnsEnabled ? 'thank.Digit' : 'Lions Digital Pro'" 
                    class="login-page-logo-ldp__image"
                  >
                  <div class="login-page-logo-ldp__text-container">
                    <div class="login-page-logo-ldp__text">
                      {{ isSnsEnabled ? $t('login.work_tech') : $t('login.work_tech') }}
                    </div>
                    <img 
                      :src="isSnsEnabled ? 'static/img/sns-logo_text_white.svg' : 'static/img/ldp-logo_text_white.svg'" 
                      :alt="isSnsEnabled ? 'thank.Digit' : 'Lions Digital Pro'"
                      class="login-page-logo-ldp__name"
                    >
                  </div>
                </div>
              </a>
            </div>
          </div>
        </footer>
      </div>
    </div>
    </ui-scrollbar>
  </div>
</template>
<script>
  import Authenticate from 'src/components/Authenticate/Authenticate.vue';
  import 'swiper/dist/css/swiper.css';
  import {swiper, swiperSlide} from 'vue-awesome-swiper'
  import config from '@/config'
  import {
    CONF_ADMINAPP_URL,
    CONF_CLIENT_SITE_LINK,
    CONF_CLEINT_LOGO_PREFIX,
    CONF_GET_ACCOUNT_TEXT,
    CONF_FORGET_PASSWORD_TEXT,
    CONF_USE_SNS,
    CONF_TECHNOLOGY_LINK,
    LANG,
    PRIVACY_POLICY,
    CUSTOM_LOGIN_PAGE
  } from '@/constants'
  import LangCheck from '@/components/Langs/LangCheck.vue';
  import Cookies from 'js-cookie'

  export default {
    components: {
      Authenticate,
      swiper,
      swiperSlide,
      LangCheck
    },
    data: function () {
      return {
        connectSystems: false,
        alertText: '',
        alertType: 'success',
        notificationText: '',
        showLoginHelp: false,
        swiperOption: {
          loop: true,
          effect: 'fade',
          grabCursor: true,
          fadeEffect: {
            crossFade: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            disabledClass: 'disabled'
          }
        },
        validationError: '',
        createAccInfo: false,
        createAccText: '',
        adminAppUrl: config(CONF_ADMINAPP_URL),
        clientLink: config(CONF_CLIENT_SITE_LINK),
        clientLogoPrefix: config(CONF_CLEINT_LOGO_PREFIX),
        getAccountText: config(CONF_GET_ACCOUNT_TEXT) || null,
        forgetPasswordText: config(CONF_FORGET_PASSWORD_TEXT) || null,
        infoType: 0,
        windowWidth: 0
      }
    },
    computed: {
      isSnsEnabled() {
        return config(CONF_USE_SNS) !== false;
      },
      technologyLink() {
        return config(CONF_TECHNOLOGY_LINK) || 'https://lionsdigital.pro';
      },
      customLoginPage () {
        return config(CUSTOM_LOGIN_PAGE);
      },
      customBackground () {
        if (this.windowWidth <= 1200 && this.customLoginPage && this.customLoginPage.BACKGROUND_MOBILE) {
          return this.customLoginPage.BACKGROUND_MOBILE;
        }

        if (this.customLoginPage && this.customLoginPage.BACKGROUND) {
          return this.customLoginPage.BACKGROUND;
        }

        return 'login-page_background.jpg'
      },
      customBackgroundPosition () {
        if (this.windowWidth <= 1200 && this.customLoginPage && this.customLoginPage.BACKGROUND_MOBILE) {
          return 'center';
        }

        if (this.customLoginPage && this.customLoginPage.BACKGROUND_POSITION_TOP) {
          return `center ${this.customLoginPage.BACKGROUND_POSITION_TOP}`;
        }

        return 'center'
      },
      customAntiCircle () {
        if (this.customLoginPage && this.customLoginPage.SHOW_ANTI_CIRCLE === false) {
          return false;
        }

        return true;
      },
      customAdvantagesCircleBackground () {
        if (this.customLoginPage && this.customLoginPage.ADVANTAGES_CIRCLE_BACKGROUND) {
          return this.customLoginPage.ADVANTAGES_CIRCLE_BACKGROUND;
        }

        return null
      },
      customH2Color () {
        if (this.customLoginPage && this.customLoginPage.H2_COLOR) {
          return this.customLoginPage.H2_COLOR;
        }

        return '#fff'
      },
      customAdvantagesColor () {
        if (this.customLoginPage && this.customLoginPage.ADVANTAGES_COLOR) {
          return this.customLoginPage.ADVANTAGES_COLOR;
        }

        return '#fff'
      },
      policyHref () {
        return config(PRIVACY_POLICY) || '';
      },
      lang () {
        return this.$store.state.lang
      },
      logoSrc () {
        return `static/img/logos/${this.clientLogoPrefix}_login_${this.lang}.svg`;
      },
      logoSrcDefault () {
        return `static/img/logos/${this.clientLogoPrefix}_login_en.svg`;
      },
      footerLogoSrc () {
        return `static/img/logos/${this.clientLogoPrefix}_white_new_${this.lang}.svg`;
      },
      footerLogoSrcDefault () {
        return `static/img/logos/${this.clientLogoPrefix}_white_new_en.svg`;
      }
    },
    methods: {
      updateWindowWidth () {
        this.windowWidth = window.innerWidth;
      },
      onShowCreateAcc () {
        this.infoType = 1;
        this.createAccText = this.getAccountText[this.lang.toUpperCase()] || this.getAccountText.EN;
        this.showLoginHelp = !this.showLoginHelp
      },
      onShowForgotPassword () {
        this.infoType = 2;
        this.createAccText = this.forgetPasswordText[this.lang.toUpperCase()] || this.forgetPasswordText.EN;
        this.showLoginHelp = !this.showLoginHelp
      },
      onRecoveryCodeSended () {
        this.notificationText = this.$t('login.notifications.recover_email');
      },
      onPasswordChanged () {
        this.alertText = this.$t('login.notifications.password_changed');
      },
      onLoginCancel () {
        this.$emit('login-canceled')
      },
      onLoginSuccess (pathTo) {
        this.$router.push(pathTo)
      },
      showError (err) {
        this.validationError = err;
      },
      showCreateAcc () {
        this.createAccInfo = !this.createAccInfo;
      },
      hideError () {
        this.validationError = null;
        this.notificationText = '';
        this.alertType = 'success'
        this.alertText = ''
      }
    },
    mounted () {
      this.$bus.$emit('close-relogin-on-fly');
      this.$bus.$on('E_USER_NOT_ACTIVE', () => {
        this.alertType = 'error'
        this.alertText = this.$t('login.notifications.profile_blocked');
      })

      this.updateWindowWidth();
      window.addEventListener('resize', this.updateWindowWidth);
    },
    beforeDestroy () {
      this.$bus.$off('E_USER_NOT_ACTIVE')

      window.removeEventListener('resize', this.updateWindowWidth);
    },
    watch: {
      lang (val) {
        if (this.infoType === 1) {
          this.createAccText = this.getAccountText[val.toUpperCase()] || this.getAccountText.EN;
        } else if (this.infoType === 2) {
          this.createAccText = this.forgetPasswordText[val.toUpperCase()] || this.forgetPasswordText.EN;
        }
      }
    }
  }
</script>

<style lang="scss">
  @import "src/assets/sass/grid";
  @import 'src/assets/sass/paper/variables';
$screen-sm:           768px;
$screen-md:           992px;
$screen-lg:           1200px;
$max-container-width: $screen-lg;

 .login-page{
   &--wrapper {
     display:block !important;
     width: 100%;
     .bz-scrollbar__content--wrapper {
       display: flex;
       flex-direction: column;
     }
     @media only screen and (min-width: $screen-md) {
       display: flex;
     }
   }
  flex: 1;
   @media only screen and (min-width: $screen-md) {
     display: flex;
     overflow: hidden;
     min-height: 100%;
   }
  position: relative;

  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  .preheader{
    .container{max-width: 1200px;}
  }

  &__container {
    display: grid;
    grid-template-rows: 75px auto auto;

    .app--is-widget & {
      grid-template-rows: 60px auto;
    }

    @media only screen and (min-width: $screen-md){
      flex: 1;
      grid-template-rows: 75px auto 97px;

      .app--is-widget & {
        grid-template-rows: 60px auto;
      }
    }
  }

  &__substrate-mobile {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: auto;
    min-width: 100%;

    @media only screen and (min-width: $screen-md) {
      display: none;
    }
  }

  &__substrate-desktop {
    display: none;
    position: absolute;
    left: -80px;
    top: 0;
    height: 100%;
    width: 100%;
    opacity: .7;

    @media only screen and (min-width: $screen-md) {
      display: block;
    }
  }

  h1, h2, h3 {
    font-family: inherit;
  }

  a {
    font-family: inherit;

    &:focus {
      outline: none;
    }
  }
}

.login-page-header {
  position: relative;
  z-index: 1;
  background: #fff;

  .langs-select {
    margin-left: auto;
  }

  &__container {
    display: flex;
    height: 100%;
    justify-content: flex-start;
    align-items: center;
    padding: 0 25px;

    @media only screen and (min-width: $screen-lg) {
      max-width: $max-container-width;
      margin: 0 auto;
    }
    @media only screen and (max-width: $screen-xs) {
      padding-left: 12px;
    }
  }
}

.login-page-logo {
  height: 100%;
  display: flex;
  align-items: center;

  &__img {
    margin-right: 5px;
    position: relative;
    top: 5px;
  }

  &__text {
    display: inline-block;
    margin: 0;
    font-weight: 700;
    font-size: 14px;
    color: #1E5A9F;
    max-width: 165px;
    padding-right: 10px;
  }
}


.login-page-content {
  overflow: auto;
  &__container {
    position: relative;
    width: 100%;
    max-width: $max-container-width;
    z-index: 0;
    display: grid;
    padding: 20px 25px 0 25px;
    grid-template-columns: minmax(280px, 430px);
    justify-content: center;
    grid-row-gap: 50px;
    grid-template-areas:
    "form"
    "slider";

    @media only screen and (min-width: $screen-sm) {
      grid-row-gap: 30px;
    }

    @media only screen and (min-width: $screen-md) {
      height: 100%;
      grid-template-columns: minmax(280px, 529px) minmax(280px, 430px);
      align-items: center;
      justify-content: space-between;
      grid-template-areas:
      "slider form";
      grid-column-gap: 30px;
    }

    @media only screen and (min-width: $screen-lg) {
      margin: 0 auto;
    }

    .app--is-widget & {
      grid-row-gap: 0;
    }
  }
  &__alert {
    background: #CEF2DB;
    padding: 25px 60px;
    font-size: 14px;
    color: #15BF51;
    margin-bottom: 10px;
    border-radius: 4px;
    &.error{
      background: #feedc2;
      box-shadow: 0 14px 24px rgba(0,0,0,.15);
      line-height: 1.3;
      color: #f3af37;
    }
  }
}

.login-page-slider {
  grid-area: slider;
  position: relative;
  padding-top: 60px;

  @media only screen and (min-width: $screen-md) {
    padding-top: 0;
  }

  .swiper-wrapper {
    @media only screen and (min-width: $screen-md) {
      display: flex;
      align-items: center;
    }
  }

  &__navigation {
    position: absolute;
    left: 0;
    top: 0;
    display: flex;


    @media only screen and (min-width: $screen-md) {
      left: auto;
      right: 0;
      top: 10%;
    }
  }

  .swiper-button-next,
  .swiper-button-prev {
    position: static;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 34px;
    margin-right: 1px;
    background: #fff;
    box-shadow: 0px 14px 24px rgba(0, 0, 0, 0.15);
    cursor: pointer;

    &:focus {
      outline: none;
    }

    &.disabled {
      cursor: default;
      svg {
        opacity: .3;
      }
    }
  }

  .swiper-button-next {
    border-radius: 0 100% 100% 0;
  }

  .swiper-button-prev {
    border-radius: 100% 0 0 100%;
  }

  &__item {

    @media only screen and (min-width: $screen-sm) {
      width: 100% !important;
    }

    h2 {
      max-width: 425px;
      margin:0 0 35px 0;
      font-size: 30px;
      line-height: 1.2;
      color: #fff;
      font-weight: 700;

      br {
        display: none;
      }

      @media only screen and (min-width: $screen-md) {
        font-size: 40px;
        padding-bottom: 0;
        max-width: 350px;
      }
    }
  }
}

.login-page-slide-advantages {

  padding-bottom: 25px;

  &__item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  &__icon {
    height: 60px;
    width: 60px;
    margin-right: 17px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;

    &--orange {
      background: linear-gradient(140.34deg, #F6B5A0 8.73%, #F2796D 87.5%);
    }

    &--green {
      background: linear-gradient(140.34deg, #A6EBCF 8.73%, #52C299 87.5%);
    }

    &--purple {
      background: linear-gradient(140.34deg, #C3AFFC 8.73%, #996DD4 87.5%);
    }
  }

  &__title {
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    color: #fff;

    @media only screen and (min-width: $screen-md) {
      font-size: 24px;
    }
  }
}

.login-page-slide-patient-record {

  &__button {
    display: inline-block;
    padding: 10px 22px;
    border-radius: 3px;
    background: #A47DDE;
    font-size: 14px;
    font-weight: 600;
    color: #fff;
    transition: all .2s;

    &:hover {
      color: #fff;
      box-shadow: 0px 14px 24px rgba(164, 125, 222, .2);
    }

    &:focus {
      color: #fff;
    }

    &:active {
      background: #a061ff;
    }
  }

  &__image {
    max-width: 380px;
    overflow: hidden;

    img {
      width: 100%;
      margin-top: 65px;
      margin-bottom: -70px;

      @media only screen and (min-width: $screen-sm){
        margin-top: 32px;
      }

      @media only screen and (min-width: $screen-md){
        margin-bottom: 0;
      }
    }
  }
}

.login-page-slide-release {
  position: relative;
  padding-bottom: 25px;

  @media only screen and (min-width: $screen-sm){
    padding-left: 80px;
  }

  &__icon {
    height: 60px;
    width: 60px;
    margin-bottom: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    background: linear-gradient(140.34deg, #FF8585 8.73%, #EB5757 87.5%);

    @media only screen and (min-width: $screen-sm){
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  &__title {
    margin-top: 0;
    margin-bottom: 12px;
    color: #fff;
    font-size: 16px;
    font-weight: 700;

    @media only screen and (min-width: $screen-md){
      font-size: 24px;
      margin-bottom: 30px;
    }
  }

  &__date {
    margin-bottom: 12px;
    font-size: 12px;
    color: #fff;
    opacity: .5;
    @media only screen and (min-width: $screen-md){
      font-size: 16px;
      margin-bottom: 17px;
    }
  }

  &__text {
    font-size: 14px;
    color: #fff;
    line-height: 1.5;
    @media only screen and (min-width: $screen-md){
      font-size: 16px;
    }
  }
}

.login-page-form {
  grid-area: form;
  background: #fff;
  border-radius: 10px;
  margin-bottom: 18px;

  .login-page-form__logo.login-page-form_logo_new {
    padding-bottom: 0;
    border-bottom: none;
  }

  &__help-login-text {
    font-size: 14px;
    line-height: 16px;
    color: #999ba1;
    cursor: pointer;
    &:hover {
      color: #73777e;
    }
  }

  &__form-container {
    position: relative;
  }

  .form {
    padding: 0 20px 20px 20px;
    @media only screen and (min-width: $screen-sm){
      padding: 0 60px 40px 60px;
    }
  }

  &__logo {
    text-align: center;
    padding: 26px 10px 0;

    img {
      max-width: 229px;
    }
  }

  &__legend {
    padding: 20px;
    color: #2B2927;
    font-size: 20px;
    font-weight: 700;

    @media only screen and (min-width: $screen-sm){
      padding: 30px 60px 30px 60px;
      font-size: 24px;
    }
  }

  &__sub-legend {
    margin-bottom: 20px;
    padding: 0 20px;
    font-weight: 500;
    color: #838A99;

    @media only screen and (min-width: $screen-sm){
      padding-left: 60px;
      padding-right: 60px;
    }
  }


  &__error {
    display: block;
    width: 100%;
    padding: 10px 20px;
    border-radius: 2px;
    background: #FF5656;
    font-size: 12px;
    font-weight: 400;
    color: #fff;

    @media only screen and (min-width: $screen-sm){
      margin-top: 0;
    }
  }
  &__notification {
    display: block;
    width: 100%;
    padding: 10px 20px;
    border-radius: 2px;
    background: #CEF2DB;
    font-size: 12px;
    font-weight: 400;
    color: #15BF51;

    @media only screen and (min-width: $screen-sm){
      margin-top: 0;
    }
  }

  &__create-account {
    padding: 18px 20px 19px 20px;
    border-top: 1px solid #ECEAE8;
    text-align: center;

    @media only screen and (min-width: $screen-sm){
      padding: 18px 60px 21px 60px;
    }
  }

  &__disablenotif {
    font-size: 14px;
    line-height: 16px;
    color: rgba(144, 147, 153, 1);
  }

  &__enterby {
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      margin-right: 20px;
    }

    @media all and (min-width: $screen-sm) {
      margin: 0 20px 0 0;
    }
  }

  &__create-account-link {
      display: inline-block;
      color: #ACACAC;
      border-bottom: 1px solid #ACACAC;
      line-height: 1.2;
      font-weight: 500;
      cursor: pointer;
      user-select: none;

      &:hover {
        border-color: transparent;
      }
  }

  &__create-account-text {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    padding: 0 20px;
    height: 100%;
    z-index: 1;
    background: #fff;
    font-size: 21px;
    font-weight: 700;
    color: #A6A6A6;

    @media only screen and (min-width: $screen-sm) {
      padding: 0 60px;
    }
  }
}

.login-page-footer {
  position: relative;
  z-index: 1;

  &__policy {
    font-size: 14px;
    line-height: 1;
    color: #fff;
    margin-top: 8px;

    &-link {
      color: #fff;
      text-decoration: underline;

      &:hover {
        color: #fff;
        opacity: 0.8;
        text-decoration: none;
      }
    }
  }

  &__wrapper {
    @media only screen and (min-width: $screen-lg) {
      height: 100%;
      max-width: $max-container-width;
      margin: 0 auto;
      padding: 0 25px;
    }
  }

  &__container{
    display: flex;
    // display: grid;
    align-items: center;
    flex-direction: column;
    // grid-template-areas:
    // "logo"
    // "link-1"
    // "logo-ldp";
    border-top: 1px solid rgba(252, 252, 252, .2);

    @media only screen and (min-width: $screen-sm) {
      // grid-template-areas:
      // "link-1"
      // "logo . logo-ldp";
      flex-direction: row;
      width: 100%;
      justify-content: space-between;
    }

    @media only screen and (min-width: $screen-md) {
      // grid-template-areas:
      // "link-1 logo logo-ldp";
      .login-page-footer-link {
        margin: 0 auto;
      }
    }
  }
}

.login-page-footer-logo {
  grid-area: logo;
  display: block;
  padding: 25px;
  min-width: 218px;

  @media only screen and (min-width: $screen-sm) {
    min-width: 260px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  @media only screen and (min-width: $screen-lg) {
    padding-left: 0;
  }

  img {
    max-width: 218px;
    max-height: 76px;
  }
}

.login-page-logo-ldp__text-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  img {
    max-width: 100%;
  }
}


.login-page-footer-note {
  color: #fff;
  font-family: Roboto;
  font-size: 16px;
  line-height: 19px;
}

.login-page-footer-link {
  padding: 0 25px;

  @media only screen and (min-width: $screen-sm){
    // border-bottom: 1px solid rgba(252, 252, 252, .2);
    padding: 20px 0;
    margin-left: auto;
    margin: auto;
  }

  @media only screen and (min-width: $screen-md){
    border-bottom: none;
  }

  @media only screen and (min-width: $screen-lg) {
    padding-left: 0;
  }

  &:nth-of-type(2){
    grid-area: link-1;
  }

  &:nth-of-type(3){
    grid-area: link-2;
  }

  &:nth-of-type(4){
    grid-area: link-3;
  }

  &__title {
    opacity: .5;
    font-size: 10px;
    color: #fff;
    font-weight: 400;
  }

  &__link {
    font-size: 21px;
    font-weight: 700;
    color: #fff;
    line-height: 1;

    &:hover {
      opacity: .8;
      color: #fff;
    }
  }
}

.login-page-logo-ldp {
  grid-area: logo-ldp;
  display: block;
  padding: 25px;
  // border-top: 1px solid rgba(252, 252, 252, .2);

  @media only screen and (min-width: $screen-sm) {
    border-top: none;
    min-width: 260px;
  }

  @media only screen and (min-width: $screen-md) {
    justify-self: end;
  }

  @media only screen and (min-width: $screen-lg) {
    padding-left: 0;
    padding-right: 0;
  }

  &__container {
    display: flex;
  }

  &__image {
    margin-right: 13px;
  }

  &__text {
    font-size: 10px;
    margin-bottom: 5px;
    color: #fff;
    font-weight: 400;
  }
}
</style>
